<template>
    <router-view style="width: 100%;height: 100%;" />
</template>
<script setup >
</script>
<style lang="scss">
@import "./style/demo.css";
body,
html,#app {
  height: 100%;
  width: 100%;
  padding: 0!important;
}

* {
  margin: 0;
  padding: 0;
}
/* 全局CSS文件或App.vue的style */
::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Edge */
  width: 0 !important; /* Firefox兼容 */
  height: 0 !important;
  -webkit-appearance: none;
}

body {
  -ms-overflow-style: none; /* IE/Edge */
  scrollbar-width: none; /* Firefox */
  overflow: -moz-scrollbars-none; /* 老版Firefox */
}
/* 微信内置浏览器可能需要额外处理 */
.weixin-scroll-fix {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.no-scrollbar::-webkit-scrollbar {
    display: none;
}
.no-scrollbar {
    scrollbar-width: none;
}
.no-scrollbar {
    -ms-overflow-style: none;
}
::-webkit-scrollbar { width: 0 !important; }
 
::-webkit-scrollbar { width: 0 !important;height: 0; }
</style>
